import { Box, Button } from "@mui/material";
import type { FormRow } from "../types";

export interface DiffPreviewCellContext {
  applyPendingDiff: (parentRowId: string) => void;
  cancelPendingDiff: (parentRowId: string) => void;
}

export const DiffPreviewCell = (params: {
  data?: FormRow;
  context?: DiffPreviewCellContext;
}) => {
  const row = params.data;
  const ctx = params.context;
  if (!row?.diff || !ctx) return null;
  const { diff } = row;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1,
        px: 2,
        py: 1,
        backgroundColor: "rgba(255,152,0,0.06)",
        borderTop: "1px solid rgba(255,152,0,0.25)",
        borderBottom: "1px solid rgba(255,152,0,0.25)",
        fontSize: 12,
        color: "#aaa",
      }}
    >
      <span>
        Switching <strong style={{ color: "#fff" }}>{diff.fromTitle}</strong> →{" "}
        <strong style={{ color: "#fff" }}>{diff.toTitle}</strong> will reshape this subtree:
      </span>
      {diff.removed.map((k) => (
        <span
          key={`r-${k}`}
          style={{
            color: "#ff8a80",
            textDecoration: "line-through",
            fontFamily: "'JetBrains Mono', ui-monospace, monospace",
          }}
        >
          − {k}
        </span>
      ))}
      {diff.added.map((k) => (
        <span
          key={`a-${k}`}
          style={{
            color: "#a5d6a7",
            fontFamily: "'JetBrains Mono', ui-monospace, monospace",
          }}
        >
          + {k}
        </span>
      ))}
      <Box sx={{ flex: 1 }} />
      <Button
        size="small"
        variant="outlined"
        onClick={() => ctx.applyPendingDiff(diff.parentRowId)}
        sx={{
          color: "#66bb6a",
          borderColor: "rgba(102,187,106,0.5)",
          textTransform: "none",
          "&:hover": { borderColor: "#66bb6a", backgroundColor: "rgba(102,187,106,0.08)" },
        }}
      >
        Apply
      </Button>
      <Button
        size="small"
        onClick={() => ctx.cancelPendingDiff(diff.parentRowId)}
        sx={{ color: "#fff", textTransform: "none" }}
      >
        Cancel
      </Button>
    </Box>
  );
};
